import { requestHandler } from 'utils/functions';
import { AppDispatch } from '../store';
import apiServices from 'api_services/request-handler';
import { setDashboardLoading, setStates } from '../slices/dashboard-slice';

export const getDashboardStates = (params: any) => {
  return async (dispatch: AppDispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getDashboardStates,
        setLoading: setDashboardLoading,
        setData: setStates,
        param_data: params
      }),
    );
  };
};
